import { render, staticRenderFns } from "./cgstatus.vue?vue&type=template&id=e137e870&scoped=true"
import script from "./cgstatus.vue?vue&type=script&lang=js"
export * from "./cgstatus.vue?vue&type=script&lang=js"
import style0 from "./cgstatus.vue?vue&type=style&index=0&id=e137e870&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e137e870",
  null
  
)

export default component.exports